export const saveJSONFile = (filename: string, data: object) => {
  const blob = new Blob([JSON.stringify(data)])
  const link = document.createElement('a')
  link.download = filename
  link.href = window.URL.createObjectURL(blob)
  link.click()
}
